export default {
  install(Vue) {
    //img 오류시 변경
    Vue.prototype.$changeDefaultImage = function (e) {
      e.target.src = require('@/assets/images/page/recom_img01.jpg');
    };
  },
};
